import { Message } from 'element-ui'

// 消息框
export const operationMessage = (isTask: boolean) => {
    const text = isTask ? 'The task was created successfully, please contact another administrator for approval' : 'Operation Successfully!'
    Message({
        type: 'success',
        message: text
      })
}